import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { fetchExportTable } from '../data/fetchTable';
import moment from 'moment';
import FileDownload from 'js-file-download';
import { exportDateFormat } from '@/utilities/constants';
import { computed } from 'vue';
import { useStore } from 'vuex';
import bus from '@/helpers/events/bus';
import { useMixpanelCultureReportExport } from '@/utilities/mixpanel/registrationCulture';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistrationCultureExportTable',
    props: {
        preset: {},
        dates: {},
        query: {}
    },
    emits: ['isLoadingExport'],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const selectedBrand = computed(() => store.state.auth.selectedBrand.brand);
        const fetchExportData = async (fileType) => {
            useMixpanelCultureReportExport('view_oto-registration-culture_export-table', fileType, props.preset, props.dates, props.query);
            emit('isLoadingExport', true);
            bus.$emit('render-page-loader', true);
            fetchExportTable(props.preset, props.dates, fileType, 'blob', props.query)
                .then(response => {
                const data = response;
                const date = moment().format(exportDateFormat);
                FileDownload(data, `Identificação em loja - ${selectedBrand.value} - ${date}.${fileType}`);
            })
                .finally(() => {
                emit('isLoadingExport', false);
                bus.$emit('render-page-loader', false);
            });
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createBlock(_component_el_button, {
                class: "registration-culture-btn-export",
                onClick: _cache[0] || (_cache[0] = ($event) => (fetchExportData('xlsx'))),
                round: ""
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc('_export', 2)), 1)
                ]),
                _: 1
            }));
        };
    }
});
